import React from 'react';
import Layout from '../util/layout';
import background from '../img/5.png';

const BSC = () => {
	return(
        <Layout title="BSC Rwanda">
            <div className="page-content">
                <section data-padding="top">
                    <div className="container">
                        <div data-aos="fade-up" className="row aos-init aos-animate">
                            <div className="col-12">
                                <div className="sectiontitle-element--center">
                                    <h2>Amazon Digital Office Change Management Implementation</h2>
                                </div>
                                <div className="sectiontitle-element">
                                    <p data-aos="fade-up" data-aos-delay="200" className="aos-init aos-animate">BSC, the largest ISP in Rwanda, have switched to Amazon Digital Office in order to reduce costs, speed up all their processes and improve user and customer experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-lg" data-padding="xstop">
                            <div data-aos="zoom-in" className="col-12 col-lg-6 aos-init">
                                <div className="wrapimage-element--square">
                                    <div className="image">
                                        <img src={background}  alt="" />
                                    </div>
                                </div>
                            </div>
                            <div data-aos="fade" data-aos-delay="200" className="col-12 col-lg-6 aos-init">
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>The Problem</h6>
                                            <p>BSC use paper forms extensively throughout their business processes – this includes everything from customer orders in sales, through to delivery, implementation and finance.</p>
                                            <p>The paper based forms and processes were costly, they took a long time to process (particularly with obtaining approvals from relevant managers and directors before work can be completed), and involve significant processing costs and employee time.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>The Solutions</h6>
                                            <p>Amazon Digital Office employed advanced tools and techniques to specifically design and implement a change programme for BSC. This involved carefully planned and implemented programme of change from the top-level executives to the front line staff performing their roles and using the new systems and processes.</p>
                                            <p>The programme was successfully implemented in record time with the benefits being realized, measured and reported accordingly. Amazon Digital Office technicians uses the very latest and most relevant tools and techniques to ensure successful delivery and long-lasting change.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-element" data-padding="">
                                    <div className="info">
                                        <div className="text">
                                            <h6>Outcome</h6>
                                            <p>The benefits were instantly realized from the same day of implementation (which was within hours of the forms being provided). This includes immediate reduction of costs such as paper, printers, ink, toner, and more significantly the time required to process the paper forms.</p>
                                            <p>A key benefit is that projects are implemented and completed speedily and customers are now able to receive their ISP services quicker and efficiently.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
}

export default BSC;